const analizeRideStatus = (status, eta = '', isTracker = false) => {
  let title = '';
  let etaMessage = '';
  let statusMessage = '';
  let statusItem = null;
  let key = '';
  let etaMins = '';
  eta = eta || '';

  let nowTime = new Date();
  const startingRideTime = localStorage.getItem('startingRideTime')?.replace(/"/g, '');
  const startingRideTimeInSeconds = startingRideTime === 'null' ? '' : new Date(startingRideTime).getTime() / 1000;
  const options = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };

  if (eta) {
    nowTime.setMinutes(nowTime.getMinutes() + eta);
    nowTime = new Date(nowTime);
  }
  const etaToDisplay = new Intl.DateTimeFormat('en-US', options).format(nowTime);

  const showSearchingMessages = () => {
    if (!startingRideTimeInSeconds) {
      return;
    }

    const currentTime = new Date().getTime() / 1000;
    let message = 'Sending your ride request…';
    statusItem = 1;

    if (currentTime > startingRideTimeInSeconds + 10) {
      message = 'Contacting nearby available drivers…';
      statusItem = 2;
    }

    if (currentTime > startingRideTimeInSeconds + 70) {
      message = 'Reaching out to additional drivers…';
      statusItem = 3;
    }

    if (currentTime > startingRideTimeInSeconds + 100) {
      message = 'Hang in there, driver availability is currently limited…';
      statusItem = 4;
    }

    return message;
  };

  switch (status) {
    case 'reassigning':
    case 'provider_submitted':
    case 'riderway_submitted':
    case 'manual_dispatch':
    case 'submitted':
      key = 'requestingRide';
      title = 'Requesting Your Ride';
      etaMessage = `We're looking for the nearest available driver...`;
      statusMessage = showSearchingMessages();
      break;
    case 'assigned':
    case 'dispatched':
    case 'dispatch_pending':
      key = 'assignedRideState';
      title = 'Ride Assigned';
      etaMins = `${eta}`;
      etaMessage = `Your ride will arrive at ${etaToDisplay}`;
      statusItem = null;
      break;
    case 'on_site':
      key = 'onsiteRideState';
      title = 'Ride Arriving';
      statusItem = null;
      break;
    case 'enroute':
      key = 'enrouteRideState';
      title = 'In Ride';
      break;
    case 'completed':
      title = isTracker ? 'This ride is no longer in progress.' : '';
      break;
    case 'canceled':
    case 'missed':
    case 'review':
      key = 'canceledRideState';
      title = 'This ride is no longer in progress.';
      break;
    default:
      break;
  }

  return { key, title, etaMins, etaMessage, statusMessage, statusItem };
};

export default analizeRideStatus;
